import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from 'environments-lib';
import { DatasourceFileResponseIntermediate, IEnvironment, IFileDataSourceApiService, INamespace } from 'interfaces-lib';
import { Observable, of } from 'rxjs';

export const LocalFileNamespace: INamespace = {
  name: 'localfile',
};

@Injectable({
  providedIn: 'root',
})
export class LocalFileDatasourceService implements IFileDataSourceApiService {
  constructor(private http: HttpClient, @Inject(ENVIRONMENT) private environment: Partial<IEnvironment>) {}

  postFile(file: File, fileParams: any): Observable<any> {
    const url = `${this.environment.kpHost}/file/localfile/${fileParams.path}`;
    const formData = new FormData();
    formData.append('file', file);
    const body = formData;
    // console.log(file, fileParams, body);
    return this.http.post<any>(url, body);
  }

  // TODO: Is this right....?
  checkFile(id: string): Observable<boolean> {
    return of(true);
  }

  getFileData(fileDatasourcePath: string[]): Observable<DatasourceFileResponseIntermediate> {
      throw new Error('Method not implemented.');
  }
}
